/*
 * DRIVLY-UI React Components
 * @license MIT
 */
class t{constructor(t){this.isMounted=!1,this.node=t}update(){}}export{t as Feature};
//# sourceMappingURL=Feature.js.map
